export default __webpack_public_path__ + "static/media/emoji-done.71561a0a.svg";